// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  ModelListDiv,
  ModelListTable,
  DeleteIcon
} from '../../../../../components/ModelListStyles';
import FailedMerchantsTableHead from './FailedMerchantsTableHead';
import FailedMerchantsTableBody from './FailedMerchantsTableBody';
import Paginator from '../../../../../components/Paginator';
import {
  loadFailedMerchants,
  expandRow,
  deleteFailedMerchant,
  deleteAllFailedMerchants,
  changePage
} from '../reducer';
import { type FailedMerchant } from '../../../../../utilities/types';
import { initialize } from 'redux-form';
import { getPaginatedMerchants } from '../../selectors';
import {
  IconTextLinkButton,
  DeleteAllDiv,
  TableTitleDiv,
  FailedMerchantsDiv
} from '../ImportCsvStyles';
import { Default, Mobile } from '../../../../../components/Responsive';
import { showModal } from '../../../../../modules/ModalConductor/reducer';
import { CONFIRMATION_MODAL } from '../../../../../modules/ModalConductor/modalTypes';

type Props = {
  currentPage: number,
  changePage: (value: number) => void,
  previouslyVisited: number[],
  total: number,
  loadFailedMerchants: () => void,
  failedMerchants: FailedMerchant[],
  loading: boolean,
  expandRow: (id: number) => void,
  failedLoad: boolean,
  expandedRowId: ?number,
  deleteFailedMerchant: (failedMerchantId: number, showModal?: boolean) => void,
  initialize: (value: string, {}) => void,
  deleteAllFailedMerchants: () => void,
  showModal: (modal?: string, payload?: any) => void
};

class FailedMerchants extends Component<Props> {
  componentDidMount() {
    this.props.loadFailedMerchants();
  }
  handleDeleteAllClick = () => {
    this.props.showModal(CONFIRMATION_MODAL, {
      onConfirm: () => this.props.deleteAllFailedMerchants(),
      title: 'Delete Failed Merchant Applications',
      message:
        'Are you sure you want to delete all failed merchant applications?'
    });
  };
  handleDeleteClick = (merchantId: number) => {
    this.props.showModal(CONFIRMATION_MODAL, {
      onConfirm: () => this.props.deleteFailedMerchant(merchantId, true),
      title: 'Delete Merchant Application',
      message: 'Are you sure you want to delete this merchant application?'
    });
  };
  render() {
    const showFailedMerchantsTable = this.props.failedMerchants.length > 0;
    const paginatorTotal = Math.ceil(this.props.total / 10);
    // if (!showFailedMerchantsTable) {
    //   return null;
    // } else {
    return (
      <FailedMerchantsDiv>
        <TableTitleDiv>
          <h5>Failed Merchant Applications</h5>
          <DeleteAllDiv>
            {showFailedMerchantsTable && (
              <IconTextLinkButton onClick={this.handleDeleteAllClick}>
                <DeleteIcon name="delete" />
                <Mobile>
                  <h6>Delete All </h6>
                </Mobile>
                <Default>
                  <h6>Delete All Failed Applications</h6>
                </Default>
              </IconTextLinkButton>
            )}

            <h6>
              <span>Total: {this.props.total}</span>
            </h6>
          </DeleteAllDiv>
        </TableTitleDiv>
        <ModelListDiv>
          <ModelListTable>
            <FailedMerchantsTableHead />
            <tbody>
              <FailedMerchantsTableBody
                failedMerchants={this.props.failedMerchants}
                loading={this.props.loading}
                failedLoad={this.props.failedLoad}
                expandRow={this.props.expandRow}
                expandedRowId={this.props.expandedRowId}
                deleteFailedMerchant={this.handleDeleteClick}
                initializeForm={this.props.initialize}
              />
            </tbody>
          </ModelListTable>
          {this.props.failedMerchants.length > 0 && (
            <Paginator
              paginatorTotal={paginatorTotal}
              currentPage={this.props.currentPage}
              changePage={this.props.changePage}
              previouslyVisited={this.props.previouslyVisited}
            />
          )}
        </ModelListDiv>
      </FailedMerchantsDiv>
    );
  }
}

const mapStateToProps = state => ({
  currentPage:
    state.merchants.merchantRegistrations.merchantRegistrationsCsv.currentPage,
  previouslyVisited:
    state.merchants.merchantRegistrations.merchantRegistrationsCsv
      .previouslyVisited,
  total:
    state.merchants.merchantRegistrations.merchantRegistrationsCsv
      .failedMerchants.length,
  failedMerchants: getPaginatedMerchants(state),
  loading:
    state.merchants.merchantRegistrations.merchantRegistrationsCsv.loading,
  failedLoad:
    state.merchants.merchantRegistrations.merchantRegistrationsCsv.failedLoad,
  expandedRowId:
    state.merchants.merchantRegistrations.merchantRegistrationsCsv.expandedRowId
});

const mapDispatchToProps = {
  loadFailedMerchants,
  changePage,
  expandRow,
  deleteFailedMerchant,
  initialize,
  showModal,
  deleteAllFailedMerchants
};

export default connect(mapStateToProps, mapDispatchToProps)(FailedMerchants);
